import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import { Tabs } from 'antd';
import SettingsDropdowns from "../../containers/PaidMedia.js/SettingsDropdowns";

const MarketingSettingsPage = () => {
  return (
    <PageLayout
      title="Marketing Settings"
      subTitle="Configure and manage your marketing preferences and settings"
      dropdowns={<GenericReportingDropdowns
        includeDateRange={true}
        includeRegion={false}
        includeSingleSelectRegion={true}
        includeGranularity={false}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={false}
      />}
      content={<div>
        <Tabs>
            <Tabs.TabPane tab="Google" key="google">
                <SettingsDropdowns platform="google" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Facebook" key="facebook">
                <SettingsDropdowns platform="facebook" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Tiktok" key="tiktok">
                <SettingsDropdowns platform="tiktok" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Snapchat" key="snapchat">
                <SettingsDropdowns platform="snapchat" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Bing" key="bing">
                <SettingsDropdowns platform="bing" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Pinterest" key="pinterest">
                <SettingsDropdowns platform="pinterest" />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Reddit" key="reddit">
                <SettingsDropdowns platform="reddit" />
            </Tabs.TabPane>
        </Tabs>
      </div>}
    />
  );
};

export default MarketingSettingsPage;
